












































































































































import { Component, Vue } from 'nuxt-property-decorator';
import { blogStore } from '~/store';
import { IBlogArticle } from '~/models';
import { FreeTrialButton, FreeTrialButtonBlue } from '~/components';

@Component({
  components: {
    FreeTrialButton,
    FreeTrialButtonBlue
  }
})
export default class BlogDetail extends Vue {
  async asyncData({ params }) {
    await blogStore.getBySlug({ slug: params.slug });
  }

  get current () : IBlogArticle {
    return blogStore.current;
  }

  get next () : IBlogArticle | null {
    return blogStore.next;
  }

  get previous () : IBlogArticle | null {
    return blogStore.previous;
  }

  get nextBlogs () : IBlogArticle[] {
    return blogStore.nextBlogs;
  }
}
